module.exports = __webpack_public_path__ + "static/media/Download.7e928e6f.gif";